var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[_c('Header',{attrs:{"active-nav":_vm.activeNav},on:{"nav-click":_vm.handleNavClick}}),_c('div',{staticClass:"page-content"}),_c('Footer',{on:{"scroll-to":_vm.handleScrollTo,"show-product":_vm.handleShowProduct}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }